import { Trans } from 'react-i18next'
import NotificationBar from '~/components/NotificationBar'
import { useCalcGasFeeRisk } from '~/components/Exchange/hooks'

interface Props {
  gasFeeTokenAmount: bigint
}

const GasFeeRiskCalculator: React.FC<Props> = ({ gasFeeTokenAmount }) => {
  const { level, percentage } = useCalcGasFeeRisk(gasFeeTokenAmount)

  if (level === 'info') return null

  return (
    <NotificationBar
      level="warning"
      text={
        <Trans
          i18nKey="gas_fee_risk_alert"
          values={{ percentage: percentage.toFixed(1) }}
          components={{
            special: <span style={{ fontWeight: 700 }}>{percentage}%</span>,
          }}
        />
      }
      showIcon={false}
      showLink={false}
      showClose={false}
      style={{ marginTop: '8px' }}
    />
  )
}

export default GasFeeRiskCalculator
